module.exports = __webpack_public_path__ + "media/app/assets/imgs/events/more-b80f223a25efa28d6f7f19fdac2841cc.svg";